import strings from 'strings';

export const COPIES = strings.sendoutsV2.form.sections.sendoverReasons;

export const SENDOVER_REASONS = [
  COPIES.reasons.couldNotConnectLive,
  COPIES.reasons.needToShowResume,
  COPIES.reasons.needToCheckSchedule
];

export const FORM_FIELDS_MAP = {
  SendoverReasons: {
    key: 'sendoverReasons'
  },
  Comments: {
    key: 'comments'
  }
};
